import { render, staticRenderFns } from "./SectionQualita.vue?vue&type=template&id=380c8afa&scoped=true&"
import script from "./SectionQualita.vue?vue&type=script&lang=js&"
export * from "./SectionQualita.vue?vue&type=script&lang=js&"
import style0 from "./SectionQualita.vue?vue&type=style&index=0&id=380c8afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c8afa",
  null
  
)

export default component.exports